import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { VARIANT_SLUGS } from '../App';

// Helper to get localized slug for a variant
const getLocalizedSlug = (variantKey, lang) => {
  const langSlugs = VARIANT_SLUGS[lang] || VARIANT_SLUGS['en'];
  return langSlugs[variantKey] || VARIANT_SLUGS['en'][variantKey];
};

const Footer = () => {
  const { t, language, isRTL } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  // Helper to get localized legal path
  const getLegalPath = (page) => {
    return language === 'en' ? `/${page}` : `/${language}/${page}`;
  };
  
  // Helper to get localized variant path with correct slug
  const getVariantPath = (variantKey) => {
    const slug = getLocalizedSlug(variantKey, language);
    return language === 'en' ? `/${slug}` : `/${language}/${slug}`;
  };

  return (
    <footer className="footer" dir={isRTL ? 'rtl' : 'ltr'} data-testid="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <Link to="/" className="footer-brand-link">
            <span className="footer-logo" aria-hidden="true">🎡</span>
            <span className="footer-name">wheel.expert</span>
          </Link>
          <p className="footer-tagline">
            {t('site.description').substring(0, 80)}...
          </p>
        </div>

        <div className="footer-links">
          <div className="footer-section">
            <h3>{t('nav.variants')}</h3>
            <ul>
              <li><Link to={getVariantPath('yesNo')}>{t('variants.yesNo.title')}</Link></li>
              <li><Link to={getVariantPath('namePicker')}>{t('variants.namePicker.title')}</Link></li>
              <li><Link to={getVariantPath('teamGenerator')}>{t('variants.teamGenerator.title')}</Link></li>
              <li><Link to={getVariantPath('foodWheel')}>{t('variants.foodWheel.title')}</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Legal</h3>
            <ul>
              <li><Link to={getLegalPath('privacy')} data-testid="footer-privacy">{t('footer.privacy')}</Link></li>
              <li><Link to={getLegalPath('terms')} data-testid="footer-terms">{t('footer.terms')}</Link></li>
              <li><Link to={getLegalPath('cookies')} data-testid="footer-cookies">{t('footer.cookies')}</Link></li>
              <li><Link to={getLegalPath('accessibility')} data-testid="footer-a11y">{t('footer.accessibility')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p data-testid="footer-copyright">
            {t('footer.copyright', { year: currentYear })}
          </p>
          <p className="footer-contact">
            <a href="mailto:contact@wheel.expert">contact@wheel.expert</a>
          </p>
          <p className="footer-made">
            Made with ❤️ for everyone
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
